import { Component, Input, ChangeDetectionStrategy, Inject, ViewChild, NgModuleRef, HostBinding } from '@angular/core';
import { IModalsService, IMODALS_SERVICE, TooltipDirective } from '@platform500services/p500-ui-kit';
import { InfoModal, InfoModalData } from '../../../../modals/info/info.modal';
import { ClipboardServiceInterface } from '../../../../services/clipboard/clipboard-service.interface';

@Component({
  selector: 'gtd-ui-field-default-string-whitespace-or-empty-with-copy',
  templateUrl: './string-whitespace-or-empty-with-copy.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StringWhitespaceOrEmptyWithCopyComponent {
  get data(): any {
    return this.dataValue;
  }

  @Input() set data(value: any) {
    switch (true) {
      case typeof value === 'number':
        this.dataValue = value + '';
        break;
      case value === null:
      case value === undefined:
        this.dataValue = '';
        break;
      default:
        this.dataValue = value;
        break;
    }
  }
  @Input() length = 30;
  @Input() isAttention = false;
  @Input() attentionData: InfoModalData;
  @Input() className: string;
  @Input() fullWidth = false;
  @Input() tooltipText?: string;

  @HostBinding('class') get hostClass() {
    return `${this.fullWidth ? 'w100' : ''}`;
  }

  @ViewChild(TooltipDirective, { static: false }) tooltipLink: TooltipDirective;
  public showCopiedMessage = false;
  private dataValue: any;

  constructor(
    @Inject('ClipboardServiceInterface') private clipboardService: ClipboardServiceInterface,
    @Inject(IMODALS_SERVICE) public modalsService: IModalsService,
    private moduleRef: NgModuleRef<any>
  ) {}

  copy($event: Event): void {
    $event.stopPropagation();
    this.clipboardService.copyFromContent(this.data);
    this.showCopiedMessage = true;
    setTimeout(() => {
      this.showCopiedMessage = false;
    }, 1000);
    if (this.isAttention) {
      this.modalsService.open(
        InfoModal,
        {
          data: this.attentionData,
        },
        this.moduleRef
      );
    }
  }
}
